import {Component, computed, input, output} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {Campaign, CampaignType, LoyaltyLevel, Size} from '../../../services/model';
import {TranslocoDirective, TranslocoService} from '@jsverse/transloco';
import {LoyaltyRadialBarComponent} from '../../pill-loyalty/loyalty-score-bar/loyalty-radial-bar.component';

@Component({
  selector: 'lib-campaign-card-sponsor-header',
  imports: [
    CommonModule, NgOptimizedImage, LoyaltyRadialBarComponent, TranslocoDirective,
  ],
  templateUrl: './campaign-card-sponsor-header.component.html',
  styleUrl: './campaign-card-sponsor-header.component.scss'
})
export class CampaignCardSponsorHeaderComponent {

  valueRatingOpened = output<void>();

  campaignDetails = input.required<Campaign>();
  headerLogo = computed<string>(() => {
    let logo = this.campaignDetails().logoUrl;
    if (!logo) {
      logo = this.campaignDetails().organization?.logoUrl;
    }
    return logo ?? 'assets/images/brand-default.png';
  });

  valueChipIndex = computed<number | undefined>(() => {
    const reward = this.campaignDetails().reward;
    if (reward < 10) {
      return 1;
    } else if (reward < 30) {
      return 2;
    } else if (reward < 100) {
      return 3;
    } else if (reward < 200) {
      return 4;
    } else {
      return 5;
    }
  });

  constructor(private transloco: TranslocoService) {
  }

  onValueRatingOpened($event: MouseEvent): void {
    $event.stopPropagation();
    this.valueRatingOpened.emit()
  }

  protected readonly CampaignType = CampaignType;
  protected readonly Size = Size;
  protected readonly LoyaltyLevel = LoyaltyLevel;
}
